<!--
 * @Author: wjc
 * @Date: 2023-11-10 16:01:22
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-08-10 11:16:01
 * @Description: 
-->
<template>
  <div class="footer relative bg-bg-4 text-color-whiter font-s-1.4rem py-20px lt-xs:font-s-1.6rem">
    <MRow
      align="middle"
      justify="space-between"
      :span="span"
      :gutter="$screen.higherThan('xs') ? 22 : null"
    >
      <el-col :md="18" :xs="24">
        <el-space
          size="large"
          class="links pb-20px mb-20px"
          :alignment="$screen.higherThan('sm') ? 'flex-start' : 'center'"
          :direction="$screen.higherThan('sm') ? 'vertical' : 'horizontal'"
        >
          <div class="w-full font-s-1.6rem text-left">友情链接</div>
          <el-select placeholder="请选择" class="link-select">
            <el-option value="1">
              <MLink to="https://zjt.hainan.gov.cn" target="_blank">海南省住房和城乡建设厅</MLink>
            </el-option>
            <!-- <el-option value="2">
              <MLink :to="`${config.footerWrite.adminUrl}`" target="_blank">
                海南省物业服务企业信用登记评价系统
              </MLink>
            </el-option> -->
          </el-select>
        </el-space>
        <div class="footer-details">
          <div class="footer-brand">
            <img
              src="/images/footer-association-logo.png"
              alt="海南省物业管理协会"
              class="footer-logo"
            />
          </div>
          <div class="footer-contact">
            <div class="footer-section-title">联系电话：</div>
            <img src="/images/footer-contact-phone.png" alt="0898-66182686" class="footer-phone" />
          </div>
        </div>
      </el-col>
      <el-col :md="6" :xs="24" class="wc-qrcode">
        <div class="text-center bg-#2B3954 p-8px font-s-14px">
          <img src="/images/qrcode1.jpg" class="wh-85px" />
          <div class="mt-4px text-overflow">
            <div>物业协会</div>
            <div>微信公众号</div>
          </div>
        </div>
        <div class="text-center bg-#2B3954 p-8px font-s-14px">
          <img src="/images/qrcode.jpg" alt="物业协会微信订阅号二维码" class="wh-85px" />
          <div class="mt-4px text-overflow">
            <div>物业协会</div>
            <div>微信订阅号</div>
          </div>
        </div>
      </el-col>
    </MRow>
    <div class="border-t-1px border-t-solid border-t-white/10 mt-20px">
      <MRow :span="span" :gutter="$screen.higherThan('xs') ? 20 : null">
        <el-col :xs="24" :md="16" class="font-s-1.4rem text-color-3 pt-20px lt-xs:font-s-1.6rem">
          <el-row>
            <el-col :md="4" :xs="24">© 2000-{{ new Date().getFullYear() }}</el-col>
            <el-col :md="8" :xs="24">{{ config.footerWrite.url }}</el-col>
            <el-col :md="8" :xs="24">{{ appName }}</el-col>
          </el-row>
        </el-col>
        <el-col
          :xs="24"
          :md="8"
          class="font-s-1.4rem text-color-3 pt-20px lt-xs:font-s-1.6rem lt-xs:text-left md:text-right"
        >
          <MLink to="https://beian.miit.gov.cn" target="_blank">琼ICP备2023015601号-1</MLink>
        </el-col>
      </MRow>
    </div>
  </div>
</template>

<script setup lang="ts">
  import config, { appName } from '~/constants'
  defineOptions({
    name: 'Footer',
  })

  const $screen = useScreen()
  const span = computed(() => $screen.span.value)
</script>

<style scoped lang="scss">
  .links {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .footer-details {
    display: grid;
    grid-template-columns: minmax(282px, 1fr) minmax(0, 1.4fr);
    align-items: center;
    min-height: 96px;
  }

  .footer-brand {
    display: flex;
    align-items: center;
    min-width: 0;
    padding-right: 40px;
    border-right: 1px dashed rgba(255, 255, 255, 0.1);
  }

  .footer-logo {
    width: 282px;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  .footer-contact {
    display: flex;
    flex-direction: row;
    align-items: center;
    min-width: 0;
    padding-left: 40px;
  }

  .footer-section-title {
    font-size: 16px;
  }

  .footer-phone {
    width: 203px;
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  .wc-qrcode {
    @apply md:justify-end;
    display: grid;
    grid-template-columns: repeat(2, 98px);
    gap: 24px;
  }

  @media (max-width: 991px) {
    .wc-qrcode {
      justify-content: center;
      margin-top: 24px;
    }
  }

  @media (max-width: 639px) {
    .footer-details {
      grid-template-columns: 1fr;
      gap: 24px;
      padding: 8px 0;
    }

    .footer-brand {
      justify-content: center;
      padding-right: 0;
      border-right: 0;
    }

    .footer-contact {
      align-items: center;
      padding-left: 0;
    }
  }
</style>
